<template>
    <el-container class="el-container">
        <!--头部区域-->
        <Header/>
        <!--侧边抽屉-->
        <AsideDrawer/>
        <!--主题内容-->
        <el-main style="padding: 0">
            <!--路由占位符-->
            <router-view/>
            <!--页脚区域-->
            <Footer/>
        </el-main>

    </el-container>
</template>

<script>
  import Header from "../components/Header";
  import Footer from "../components/Footer";
  import AsideDrawer from "../components/AsideDrawer";

  export default {
    name: "Home",
    components: {
      Header,
      Footer,
      AsideDrawer
    },
  }
</script>

<style scoped lang="less">
    .el-container {
        height: 100%;
        width: 100%;
        min-height: 100%;
        position: relative;
        background-color: #fff;
        flex-direction: column;
    }
    .el-main {
        position: relative;
    }
</style>
